<template>
    <Loader v-if="loading" />
    <div v-else>
        <div class="inner screenings no-content" v-if="!invitations.length">
            <div class="headline">
                <h1>{{$t('screenings.overview.headline')}}</h1>
            </div>
            <div class="no-content-box">
                <div>
                    <h2>{{$t('screenings.none.headline')}}</h2>
                    <p>{{$t('screenings.none.text')}}</p>
                    <router-link disabled to="#" class="button green">
                        <simple-svg
                            :filepath="'images/SVG/Buttons/PlusCircle.svg'"
                            :width="'20px'"
                            :height="'20px'"
                        />
                        {{$t('screening.add.button')}}
                    </router-link>
                </div>
            </div>
        </div>

        <div class="inner screenings with-content with-tables" v-else>
            <div class="headline">
                <h1>{{$t('screenings.overview.headline')}}</h1>
            </div>

            <tabs>
                <tab :name="$t('screenings.tabs.all')">
                    <ScreeningsList :data="invitations" :headline="$t('screening.overview.all.headline')" />
                </tab>
                <tab :name="$t('screenings.tabs.unpaid')">
                    <ScreeningsList :data="draft" :headline="$t('screenings.tabs.unpaid')" />
                </tab>
                <tab :name="$t('screenings.tabs.requested')">
                    <ScreeningsList :data="requested" :headline="$t('screenings.tabs.requested')" />
                </tab>
                <tab :name="$t('screenings.tabs.in-progress')">
                    <ScreeningsList :data="inProgress" :headline="$t('screenings.tabs.in-progress')" />
                </tab>
                <tab :name="$t('screenings.tabs.completed')">
                    <ScreeningsList :data="completed" :headline="$t('screenings.tabs.completed')" />
                </tab>
            </tabs>

        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {mapGetters} from 'vuex';
    import SvgIcon from '../components/Svg.vue';
    import ScreeningsList from '../components/ScreeningsList.vue';
    import Loader from '../components/Loader.vue';
    import createEntity from "../mixins/create-entity";

    Vue.filter('formatDate', function(value) {
        if (value) {
            return moment(String(value)).format('DD-MM-YYYY')
        }
    });

    export default {
        mixins: [createEntity],
        components:{
            SvgIcon,
            ScreeningsList,
            Loader,
        },
        data: () => ({
            loading: true,
            records: [],
        }),
        computed: {
            invitations() {
                return this.extendInvitationItems(this.records);
            },
            draft() {
                return this.screeningsByStatus('draft');
            },
            inProgress() {
                return this.screeningsByStatus('inprogress');
            },
            completed() {
                return this.screeningsByStatus('completed');
            },
            requested() {
                return this.screeningsByStatus('requested');
            }
        },
        methods: {
            screeningsByStatus(status) {
                if (!this.invitations) {
                    return [];
                }

                return this.invitations.filter(invitation => {
                    return invitation.status == status ? true : false;
                });
            },
            extendInvitationItems(invitations){
                invitations.forEach(item => {
                    item.address = item.property.address;
                    item.city = String(item.property.zip_code) + ' ' + item.property.city;
                    item.status_text = this.$t('screenings.table.status.' + item.status);
                    item.deadlineOutput = item.deadline
                        ? moment(String(item.deadline)).format('DD-MM-YYYY')
                        : this.$t('screenings.table.status.nodeadline');
                })
                return invitations;
            },
            load() {
                Vue.api.get('/invitation/sent', {}, {
                    before: () => this.loading = true,
                    always: () => this.loading = false,
                    callback: response => this.records = response.data,
                });
            },
        },
        created() {
            this.load();
        }
    }
</script>
